import { Toaster } from 'sonner'

export function SonnerProvider() {
  return <Toaster richColors position="top-right" />
}
